import { apiGet } from '../../api'

export const get_entity_programs = user_id => {
  return apiGet({
    endpoint: `programs/get_entity_programs?user_id=${user_id}`
  })
}
